// @flow
import * as React from 'react';
import classNames from 'classnames';

import * as css from './Text.scss';

type Props = {
	className?: string,
	tag?: string,
	children?: React.Node,
	type?: 'S62' | 'S48' | 'S32' | 'S24' | 'S22' | 'N' | 'S1',
	weight?: 'regular' | 'bold' | 'extraBold',
};

const Text = ({ className, tag = 'p', children, type, weight }: Props) => {
	const T = tag;

	return <T className={classNames(css.text, css[type], css[weight], className)}>{children}</T>;
};

Text.defaultProps = {
	className: '',
	tag: 'p',
	children: null,
	type: 'N',
	weight: 'regular',
};

export { Text };

/**
 * L3: 32px;
 * L2: 23px;
 * L1: 19px;
 * N: 16px;
 * S1: 14px;
 */
